export class bl {
    exitoFracaso: string;
    msjFracaso: string;
    documento: string;
    cantContenedor: string;
    numeroBL: string;
    nroManifiesto: string;
    nave: string;
    linea: string;
    estado: string;
    fechaTransaccion: Date;
    codigoPago: string;
    tipoTransporte: number;
    factura: string;
    razonSocialConsignatario: string;
    codigoLocacion: string;
    codigoNave: string;
    numeroViaje: string;
    codigoRumbo: string;
    codigoConsignatario: string;
    codigoRegimen: string;
    transaccionId: number;
    codigoEstado: number;
    serieFactura: string;
    correlativoFactura: string;
    codigoDocFe: string;

    //tipoBl

    tipoBl: string;
    tramitador: string;

    //paginacion
    paginas: string;
    cantidad: string;
}

export class Maniefiesto {
    anioManfiesto: string;
    nroManifiesto: string;
}

export class Busqueda {
    numeroBl: string;
    tipoBl: string = "0";
    manifiesto: string;
    estadoBl: string = "0";
    fechainicio: string;
    fechafin: string;
    pagina: number;
}

//Listas Harcord
export const tipos_bl = [
    { codigo: "0", descripcion: "::seleccionar::" },
    { codigo: "M", descripcion: "BL Master" },
    { codigo: "H", descripcion: "BL Hijo" }
]

export const estados_liquidado = [
    { codigo: "0", descripcion: "::seleccionar::" },
    { codigo: "3", descripcion: "Liquidado" },
    { codigo: "4", descripcion: "Liquidacion Vencida" },
    { codigo: "5", descripcion: "Facturado" },
    { codigo: "6", descripcion: "Planificado" },
    { codigo: "7", descripcion: "Completado" }
]


//detalle contenedores
export class Contenedor {
    nroContenedor: string;
    fechaLimteDevolucion: string;
    tipo: string;
    tamanio: string;
    estado: string;
    servAdi: string;
    empTransporte: string;
    lugarDevolucion: string;
    codigoDevolucion: string;
    transaccionId: string;
    codigoEstDetalle: number;
    codigoEstado?: string;
    /**  Oculto     */
    nroDetalleDo: string;
    fechaCita: string;
    horaCita: string;

    //lista servicios adicionaes
    ls_servicios: Array<ServicioAdicinal>;
    //lista transportitas
    ruc_transportista: string;
    raz_transportista: string;
    //seleccionado
    check: boolean;
    numeroCita: any;
    facturaCosmos: string;
}


export class sendContenedor {
    blHijo: string;
    tipoBl: string;
    codigoLocacion: string;
    codigoNave: string;
    nroManifiesto: string;
    anioManifiesto: string;
    ruc: string;
    tipoServicio: string;

    numeroViaje: string;
    codigoRumbo: string;
    codigoRegimen: string;
    usuario: string;
    transsaccionId: number;
}


export class Transportista {
    dniTransportista: string;
    nombres: string;
    correo: string;
    rucEmpresa: string;
    razonSocialEmpresa: string;
    clave: string;
    usuario: string;
    estado: string;
}

export class ServicioAdicinal {
    codigoServicio: string;
    descripcionServicio: string;
    checked: boolean;
}



/**
 * DETALLE CLIENTES FACTURAR
 */

export class Cliente {
    rucClienteFacturar: string;
    razonSocialClienteFacturar: string;
}

export class Comprobante {
    tipoDocumento: string;
    descripcionDocumento: string;
}

export class Moneda {
    tipoMoneda: string;
    descripcionMoneda: string;
}

export class Liquidacion {
    cliente: string;
    comprobante: string;
    moneda: string;
}
//sendLiquidar pago

export class LiquidarPago {
    bl: string;
    tipoBl: string;
    codigoLocacion: string;
    codigoNave: string;
    codRumbo: string;
    ruc: string;
    dni: string;
    codigoMoneda: string;
    codCliente: string;
    tipoComprobante: string;
    regimen: string;
    listaContenedores: string; //detalles
    tipoServicio: string;
    viaje: string;
    anioMfto: string;
    nroMfto: string;

    //agregado
    usuarioLogueado: string;
}

export class Cuadricula {
    citaConfigId: string;
    fechaCita: string;
    horaCitaInicio: string;
    horaCitaTermino: string;
    textoIntervaloHora: string;
    cuposXHora: string;
    nColumnas: string;
    nFilasXHora: string;
    cupos: Array<Cupo>;
}


export class Cupo {
    citaConfigID: string;
    estadoCupo: string;
    fechaCita: string;
    horaCitaInicio: string;
    horaCitaTermino: string;
    nCupo: string;
    contenedor: Contenedor;
}

export class Transaccion {
    transaccionID: string
    montoPagar: string
    revelarMonto: string
    simboloMoneda: string
    tipoCliente: string
}

export class NotaCredito {
    nroNota: string;
    monto: string;
    tipoMoneda: string;
    simboloMoneda: string;
    fechaDocumento: string;
    tipoDocumento: string;
    nombreDocumento: string;
    monedaNc: string;
    check: boolean;
    ultimo: boolean;
}

export class Pago {
    fechaTermino: string;
    codigoPago: string;
    totalAPagar: string;
    simboloMoneda: string;
    revelarMonto: string;
    horas: string
}

export class EnviarPago {
    transaccionID: string;
    tipoCliente: string;
    listaNotasCredito: string;
}
export class Cita {
    citaConfigID: string;
    estadoCupo: string;
    fechaCita: string;
    horaCitaInicio: string;
    horaCitaTermino: string;
    nCupo: string;
    nroContenedor: string;
    nroDetalleDTO: string;
    codigoDevolucion: string;
    transaccionId: string;
    transaccionDetId: string;
    fecha: string;
}

export class DetalleLiquidacion {
    monto: string;
    simboloMoneda: string;
    cliente: string;
    moneda: string;
    tipoComprobante: string;

    ruc: string;
    razSocial: string;
}

export class EnviarCita {
    ruc: string;
    usuario: string;
    codigoLocacion: string;
    tipoServicio: string;
    codigoLugarCita: string;
    transaccionID: any;
    tipoAccion: string;
    listaDetalles: string;
}

export class CitaSeparada {
    contenedor: string;
    fechaCitaSelec: string;
    nroDetalle_DO: string;
    numeroCita: string;
}

export class PDF {
    Serie: string;
    Numero: string;
    TipoComprobante: string;
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/impo/impo.ts